export class BlobToUrlBaseValueConverter {  
  toView(blob) {
    return URL.createObjectURL(blob);
  }
}